<template>
  <div id="signin">
    <div class="row">
      <div class="card card-body col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 mx-auto">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">Log dich ein</h3>
          </div>
          <div class="panel-body">
            <form accept-charset="UTF-8" @submit.prevent="onSubmit">
              <fieldset>
                <div class="form-group">
                  <input class="form-control" placeholder="Name" name="username" type="text" v-model="username" @blur="v$.username.$touch()">
                </div>
                <div class="form-group">
                  <input class="form-control" placeholder="Passwort" name="password" type="password" v-model="password" @blur="v$.password.$touch()">
                </div>
                <input class="btn btn-lg btn-success w-100" type="submit" :disabled="v$.$invalid" value="Login">
              </fieldset>
            </form>
            <br>
            <div class="alert alert-danger" role="alert" v-if="v$.username.$error">
              Bitte einen Nutzernamen mit mindestens zwei Zeichen eingeben!
            </div>
            <div class="alert alert-danger" role="alert" v-if="v$.password.$error">
              Bitte ein Passwort eingeben!
            </div>
            <div class="alert alert-danger" role="alert" v-if="loginError">
              Fehler beim Anmelden!
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core'
  import { required, minLength } from '@vuelidate/validators'

  import { eventBus } from '../../main';

  export default {
    setup () {
      return { v$: useVuelidate() }
    },
    data () {
      return {
        username: '',
        password: '',
        loginError: false
      }
    },
    validations () {
      return {
        username: {
          required,
          minLength: minLength(2)
        },
        password: {
          required
        }
      }
    },
    methods: {
      onSubmit () {
        const formData = {
          username: this.username,
          password: this.password,
        };
        this.loginError = false;
        this.$store.dispatch('login', {username: formData.username, password: formData.password})
      }
    },
    mounted() {
      eventBus.on('loginError', () => {
        this.loginError = true;
      })
    },
    beforeUnmount() {
      eventBus.off('loginError');
    }
  }
</script>

<style scoped>
</style>
